{
  "name": "sdaia",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build-prod": "ng build --c=production"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.1.0",
    "@angular/cdk": "^19.2.16",
    "@angular/common": "^19.1.0",
    "@angular/compiler": "^19.1.0",
    "@angular/core": "^19.1.0",
    "@angular/forms": "^19.1.0",
    "@angular/material": "^19.2.16",
    "@angular/platform-browser": "^19.1.0",
    "@angular/platform-browser-dynamic": "^19.1.0",
    "@angular/router": "^19.1.0",
    "@ckeditor/ckeditor5-alignment": "^29.2.0",
    "@ckeditor/ckeditor5-angular": "^9.1.0",
    "@ckeditor/ckeditor5-build-classic": "^31.1.0",
    "@ckeditor/ckeditor5-font": "^29.2.0",
    "@ckeditor/ckeditor5-horizontal-line": "^29.2.0",
    "@fullcalendar/angular": "^6.1.19",
    "@fullcalendar/core": "^6.1.19",
    "@fullcalendar/daygrid": "^6.1.19",
    "@fullcalendar/interaction": "^6.1.19",
    "@microsoft/signalr": "^9.0.6",
    "@ng-select/ng-select": "^14.9.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "chart.js": "^4.5.1",
    "file-saver": "^2.0.5",
    "monaco-editor": "^0.52.2",
    "ng2-charts": "^8.0.0",
    "ngx-infinite-scroll": "^19.0.0",
    "ngx-monaco-editor-v2": "^19.0.2",
    "rxjs": "~7.8.0",
    "sweetalert2": "^11.21.2",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.6",
    "@angular/cli": "^19.1.6",
    "@angular/compiler-cli": "^19.1.0",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.7.2"
  }
}
